import DoctorForm from "./DoctorForm";

export default DoctorForm;
